import {
	Configuration,
	PagamentoDto,
	PaymentApi,
	PaymentsRequest,
	UpdatePaymentsRequest,
} from "@api/client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { appConfig } from "core/app.config";
import { ThunkApiConfig } from "core/store";
import getConfiguration, { decodeError, errorHandler } from "core/store/config";

enum PaymentsReducer {
	getPayments = "[PAYMENTS] Get Payments",
	updatePayments = "[PAYMENTS] Update Payments",
}

export const paymentsGetPayments = createAsyncThunk<PagamentoDto | undefined, void, ThunkApiConfig>(
	PaymentsReducer.getPayments,
	async (_, { dispatch, extra, getState }) => {
		try {
			let state = getState().pratica;

			if (!state?.idPratica) return;

			let request: PaymentsRequest = {
				idPratica: state.idPratica,
			};

			return await new PaymentApi(getConfiguration(Configuration, extra, getState)).payments(
				request
			);
		} catch (e) {
			errorHandler(e, dispatch);
		}
	}
);

export const paymentsUpdatePayments = createAsyncThunk<
	PagamentoDto | undefined,
	PagamentoDto,
	ThunkApiConfig
>(PaymentsReducer.updatePayments, async (request, { dispatch, extra, getState }) => {
	try {
		let idPratica = getState()?.pratica?.idPratica;
		let paymentsService = getState()?.payments;

		if (!idPratica) return;

		let _request: UpdatePaymentsRequest = {
			pagamentoDto: {
				...request,
				idPratica: Number(idPratica),
			},
			isTest: appConfig.isTest,
		};

		return await new PaymentApi(getConfiguration(Configuration, extra, getState)).updatePayments(
			_request
		);
	} catch (e: any) {
		if ((e as any)?.response?.status === 400) {
			const decodeErrors = await decodeError(e.response);
			throw decodeErrors.statusCode;
		} else errorHandler(e, dispatch);
	}
});
